import React from 'react';
import styled from 'styled-components';

import { RedStarIcon } from '@/assets/icons/info-icons/redStar';
import { themeVar } from '@/styles/theme';
import Button from '../button';
import Modal from './index';

interface ModalWrappedContentProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  showRequiredFields?: boolean;
  background?: boolean;
  confirmButton?: {
    id?: string;
    name: string;
    onClick: () => void;
    disabled?: boolean;
  };
  width?: string;
  isUseOutsideClick?: boolean;
  showCloseIcon?: boolean;
  showCancelButton?: boolean;
  cancelButtonName?: string;
  className?: string;
}

const ModalWrappedContent = ({
  children,
  isOpen,
  onClose,
  title,
  confirmButton,
  showRequiredFields,
  background = false,
  width,
  isUseOutsideClick = true,
  showCloseIcon = true,
  showCancelButton = true,
  cancelButtonName = 'Cancel',
  className
}: ModalWrappedContentProps) => {
  return (
    <Modal
      showCloseIcon={showCloseIcon}
      isOpen={isOpen}
      onClose={onClose}
      onEnterKey={confirmButton?.onClick}
      background={background}
      width={width}
      className={className}
      isUseOutsideClick={isUseOutsideClick}
    >
      <Container>
        {title && <Title>{title}</Title>}
        {children}
        {!!(showCancelButton || confirmButton) && (
          <Actions>
            {showCancelButton ? (
              <Button styleType="outline" onClick={onClose} size="md">
                {cancelButtonName}
              </Button>
            ) : null}
            {confirmButton ? (
              <Button id={confirmButton.id} onClick={confirmButton.onClick} styleType={confirmButton?.disabled ? 'disabled' : 'default'} size="md">
                {confirmButton.name}
              </Button>
            ) : null}
          </Actions>
        )}
        {showRequiredFields && (
          <Warning>
            <RedStarIcon width={8} fill={themeVar('context.error')} />
            Required Field
          </Warning>
        )}
      </Container>
    </Modal>
  );
};

export default ModalWrappedContent;

const Container = styled.div`
  width: 100%;
`;

const Title = styled.h1`
  font-family: 'Blinker', serif;
  font-weight: 400;
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
  padding-bottom: 15px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  column-gap: 10px;
  padding: 30px 0 15px;
`;

const Warning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 6px;
  font-family: 'Blinker', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: ${themeVar('context.error')};
`;
